<template>
  <section class="text-center p-2" ref="qrContent">
    <div v-if="qrCodeValue">
      <img src="/static/img/thai-qr-payment.png" alt="" :width="[$mq.phone ? '202' :'280']">
      <div style="position: relative;">
        <qrcode :value="qrCodeValue"
                :options="options"
                id="qrCodeImage"
                class="qr-code-image"
                ref="qrCodeImage"
                tag="img"></qrcode>
        <img src="/static/img/thai-qr-payment-logo-sm.png" :width="[$mq.phone ? '32' :'40']" alt=""
             class="qr-code-logo">
      </div>
    </div>
    <div v-else>
      <loader v-if="displayLoading"/>
      <div v-if="promptpay">
        {{ ($i18n.locale === 'th') ? promptpay.remark_th : promptpay.remark_en }}
      </div>
    </div>

    <div class="pt-3" v-if="qrCodeValue">
      <!-- Counter Timer -->
      <a href="" class="text-primary-link" @click.prevent="loadQrCode(tmpQrPaymentData)">
        <i class="fas fa-redo"></i> {{ $t('message.button.refresh') }}
      </a>

      <vac :auto-start="true"
           :end-time="new Date().getTime() + 600000"
           ref="countDownTimer"
           @finish="finishTimer()">
        <template
          v-slot:process="{ timeObj }">
          <span>{{ `${timeObj.m}:${timeObj.s}` }}</span>
        </template>
        <template
          v-slot:finish>
          <span class="text-orange">
            <i class="fa fa-exclamation-triangle"></i> {{ $t('message.promptpay.expired') }}
          </span>
        </template>
      </vac>

      <div class="mt-3" v-if="!isExpiredQrCode">
        <button class="btn btn-info btn-block" @click="downloadQrCode()">
          {{ $t('message.button.download_qr_code') }}
        </button>
        <div class="pt-2 text-remark">{{ $t('message.qr_payment.save_screenshot') }}</div>
      </div>

      <div class="mt-3 text-left">
        <span class="text-danger">
          <i class="fa fa-exclamation-triangle"></i> {{ $t('message.my_reservations.remark') }}:
        </span>
        {{ $t('message.qr_payment.remark') }}
        <div class="pt-3">
          <button class="btn btn-outline-info btn-block" @click="contactAdmin()">
            {{ $t('message.button.contact_admin') }}
          </button>
        </div>
        <hr>
      </div>

      <div class="text-left">
        <section v-if="tmpQrPaymentData.orderId && order && qrPayment">
          <div>
            <span v-if="qrPayment.payment_for === 'normal'">#{{ order.order_code }}</span>
            <span v-else>#{{ order.order_code }} - {{ $t('message.my_reservations.additional_hours') }}</span>
          </div>
          <hr>
          <div>
            <span  v-if="order.cleaning_date">
              {{ $t('message.booking.booking_step.date') }}: {{ order.cleaning_date | prettyDate }}
            </span>
            <span v-else>{{ $t('message.booking.new_booking.booking_type_flexible') }}</span>
          </div>
          <hr>
        </section>
        <div v-if="tmpQrPaymentData">
          <div class="mb-2" v-if="tmpQrPaymentData.user">
            {{ tmpQrPaymentData.user.full_name }}
          </div>
          <template v-if="tmpQrPaymentData.professionalRegisterPayment && tmpQrPaymentData.professionalRegisterPayment.professional_register">
            <div class="mb-2">
              {{ tmpQrPaymentData.professionalRegisterPayment.professional_register.firstname }} {{ tmpQrPaymentData.professionalRegisterPayment.professional_register.lastname }} ({{ tmpQrPaymentData.professionalRegisterPayment.professional_register.id_card_number }})
            </div>
            <div>
              ค่าสมัคร: {{ tmpQrPaymentData.professionalRegisterPayment.application_fee | currency }}
            </div>
            <div>
              ค่าตรวจประวัติ: {{ tmpQrPaymentData.professionalRegisterPayment.criminal_record_fee | currency }}
            </div>
          </template>
          <div class="mt-2">
            {{ $t('message.service_request.all_amount_due') }}: <b>{{ tmpQrPaymentData.amount | currency }}</b>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Loader from '../loader/Loader'
  import QrcodeVue from 'qrcode.vue'
  import axios from 'axios'
  import moment from 'moment-timezone'

  export default {
    components: {
      Loader,
      QrcodeVue
    },
    data () {
      return {
        options: {width: 278},
        qrCodeImageUrl: null,
        qrCodeValue: null,
        qrCodeSize: 240,
        apiToken: null,
        isExpiredQrCode: false,
        tmpQrPaymentData: null,
        qrPayment: null,
        displayLoading: false,
        promptpay: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      }),
      ...mapState('payment', ['qrPaymentId']),
      ...mapState('chatBooking', ['bookingData'])
    },
    methods: {
      contactAdmin () {
        const url = '/qr-payments/admin-notification'
        const submitData = {
          user_id: this.user.id,
          transaction_code: this.qrPayment.transaction_code
        }
        axios.post(url, submitData)
          .then(res => {
            const response = res.data
            console.log('response', response)
            // const userAgent = window.navigator.userAgent
            const url = 'https://line.me/R/ti/p/%40hnk7011n'
            const ua = window.navigator.userAgent.toLowerCase()
            if (ua.indexOf('safari') !== -1) {
              console.log('safari')
              window.location.href = url
            } else {
              console.log('not safari')
              window.open(url, '_blank')
            }
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      finishTimer () {
        console.log('finish timer')
        // this.loadQrCode()
        this.$refs.countDownTimer.finishCountdown()
        this.isExpiredQrCode = true
      },
      downloadQrCode () {
        const el = this.$refs.qrContent
        this.$html2canvas(el).then(canvas => {
          const dateTime = moment().format('YYYY_MM_DD_h_mm_ss')
          const fileName = `QRCode${dateTime}.png`
          console.log('fileName', fileName)
          const link = window.document.createElement('a')
          link.setAttribute('href', canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream'))
          link.setAttribute('download', fileName)
          link.click()
        }).catch((error) => {
          console.log('ERROR SAVING IMAGE', error)
        })
      },
      loadQrCode (qrPaymentData) {
        if (this.$mq.phone) {
          this.options = {width: 200}
        }
        this.tmpQrPaymentData = qrPaymentData
        if (qrPaymentData) {
          this.displayLoading = true
          this.remark = null
          this.qrCodeValue = null
          const url = '/qr-payments/create-qr-code'
          const params = {
            payment_for: qrPaymentData.paymentFor ? qrPaymentData.paymentFor : null,
            order_id: (qrPaymentData.orderId) ? qrPaymentData.orderId : null,
            chat_booking_id: (qrPaymentData.chatBookingId) ? qrPaymentData.chatBookingId : null,
            purchase_id: (qrPaymentData.purchaseId) ? qrPaymentData.purchaseId : null,
            pre_qr_payment_id: (qrPaymentData.preQrPaymentId) ? qrPaymentData.preQrPaymentId : null,
            amount: Math.round(qrPaymentData.amount * 100) / 100,
            professional_tip_id: (qrPaymentData.professional_tip_id) ? (qrPaymentData.professional_tip_id) : null,
            order_additional_hours_id: (qrPaymentData.order_additional_hours_id) ? (qrPaymentData.order_additional_hours_id) : null
          }
          axios.post(url, params)
            .then(res => {
              const response = res.data
              if (!response.error) {
                if (!response.errorCode) {
                  this.qrPayment = response.qr_payment
                  this.qrCodeValue = response.qrCode
                  // Set timer
                  this.isExpiredQrCode = false
                  // Check order qr payment
                  this.$emit('checkQrPayment', response)
                } else {
                  console.log('error gen qr code', response.errorCode, response.errorDesc)
                  this.$swal({text: response.errorDesc, type: 'error'})
                }
              } else {
                console.log('error gen qr code')
                if (response.message) {
                  const alertMessage = response.message
                  this.$swal({text: alertMessage, type: 'error'})
                }
                if (response.promptpay) {
                  this.displayLoading = false
                  this.promptpay = response.promptpay
                }
              }
            })
            .catch(error => {
              console.log('check error', error)
            })
        } else {
          this.$swal({text: 'Error: no data', type: 'error'})
        }
      }
    }
  }
</script>

<style>
  .qr-code-image {
    border: 1px solid #0e3d67;
  }

  .qr-code-logo {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/qrPayment/QrCodePayment.vue